<template>
  <div
    class="haitao-wrap"
  >
    <div class="notice">
      {{TLang('haiwaiTis', 'orderConfirm')}}
    </div>
    <el-form
      ref="haitaoForm"
      :model="haitaoForm"
    >
      <el-form-item
        :label="TLang('姓名', 'orderConfirm')"
        prop="identityCardName"
        :rules="{
          required: true, message: TLang('请输入真实姓名', 'orderConfirm'), trigger: 'blur'
        }"
      >
        <el-input
          v-model="haitaoForm.identityCardName"
          :placeholder="TLang('请输入真实姓名', 'orderConfirm')"
          autocomplete="off"
          @blur="handlerBlur"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="TLang('身份证号', 'orderConfirm')"
        prop="identityCardNo"
        :rules="[{
          required: true,
          pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
          message: TLang('请输入正确的身份证号码', 'orderConfirm'),
          trigger: 'blur'
        }]"
      >
        <el-input
          v-model="haitaoForm.identityCardNo"
          :placeholder="TLang('请输入正确的身份证号码', 'orderConfirm')"
          autocomplete="off"
          maxlength="18"
          @blur="handlerBlur"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'HaitaoForm',
  data() {
    return {
      haitaoForm: {
        identityCardName: '',
        identityCardNo: '',
      },
    };
  },
  methods: {
    ...mapActions('orderConfirm', ['onHaitao']),
    handlerBlur() {
      const { identityCardName, identityCardNo } = this.haitaoForm;
      this.onHaitao({
        identityCardName,
        identityCardNo,
      });
    },
  },
};
</script>

<style lang="less">
.haitao-wrap {
  padding: 0 24px;
  .el-form-item{
    margin-bottom: 20px;
  }
}
.notice {
  margin: 8px 0 12px;
  height:16px;
  font-size:12px;
  font-family:MicrosoftYaHei;
  color:rgba(255,175,0,1);
  background-color: #fff;
  line-height:16px;
}
/deep/ .el-form-item {
  margin-bottom: 28px;
  display: inline-block;

  .el-form-item__content {
    display: inline-block;
    .el-input__inner {
      width: 320px;
      height: 32px;
      line-height: 32px;
      border: solid 1px #e5e5e5;
      color: #333;
      border-radius: 0;

      &:first-of-type {
        margin-right: 80px;
      }
    }
  }
}
</style>
